$(document).ready(function () {
    //on scroll once
    //only execute if this class is on page
    if (document.querySelector(".animated-text") !== null) {

        //words only
        $(window).scroll(function () {
            if (document.querySelector(".animated-text") !== null) {
                var scroll = $(window).scrollTop();

                if (scroll < 300) {
                    $(".first-word").removeClass("yellow-fill");
                    $(".second-word").removeClass("yellow-fill");
                    $(".second-word").removeClass("yellow-fill");
                } else if (scroll >= 300 && scroll < 550) {
                    $(".first-word").addClass("yellow-fill");
                    $(".second-word").removeClass("yellow-fill");
                    $(".third-word").removeClass("yellow-fill");
                } else if (scroll >= 550 && scroll < 800) {
                    $(".first-word").removeClass("yellow-fill");
                    $(".second-word").addClass("yellow-fill");
                    $(".third-word").removeClass("yellow-fill");
                } else if (scroll >= 800) {
                    $(".first-word").removeClass("yellow-fill");
                    $(".second-word").removeClass("yellow-fill");
                    $(".third-word").addClass("yellow-fill");
                }
            }
        });

        //letters - find position of target text
        $(window).scroll(function (event) {
            var trigger = $(".animated-text").offset().top - $(window).outerHeight();
            //when text is at 1/3 vh trigger animation
            if (trigger + (window.innerHeight / 2) > $(window).scrollTop()) {
                console.log("working");
                return;
            }
            $(this).off(event);
        });

        var letters = $(".fill-change");

        $(window).one("scroll", function (event) {
            $(".fill-change").each(function (i) {
                (function (self) {
                    var done = false;

                    setTimeout(function () {
                        function recursive(i) {
                            if (done) return;

                            letters.eq(i).addClass("yellow-fill").delay(800);
                            letters.eq(i - 10).removeClass("yellow-fill");
                            letters.eq(i + 26).addClass("yellow-fill");

                            setTimeout(function () {
                                if (done) return;
                                recursive(++i % letters.length);
                            }, i * 15);
                        }
                        recursive(0);
                        setTimeout(function () {
                            done = true;
                        }, 4600);
                        // external event to stop loop
                    }, i * 10);
                })(this);
            });
        });

    }
});
